<div class="fixed top-6 right-6 z-50 space-y-3 max-w-sm w-full">
  @for (toast of toastService.toasts(); track toast.id) {
    <div 
      [class]="getToastClasses(toast)"
      role="alert"
      [attr.aria-live]="toast.type === 'error' ? 'assertive' : 'polite'"
    >
      <!-- Progress bar for timed toasts -->
      @if (!toast.persistent && toast.duration && toast.duration > 0) {
        <div class="progress-container">
          <div 
            class="progress-bar"
            [style.animation-duration]="toast.duration + 'ms'"
          ></div>
        </div>
      }
      
      <div class="flex items-start p-4">
        <!-- Enhanced icon with background -->
        <div class="flex-shrink-0">
          <div [class]="getIconBackgroundClasses(toast.type)">
            <svg 
              class="w-5 h-5"
              [class]="getIconClasses(toast.type)"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              @switch (toast.type) {
                @case ('success') {
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                }
                @case ('error') {
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
                }
                @case ('warning') {
                  <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.178 2.625-1.516 2.625H3.72c-1.337 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
                }
                @case ('info') {
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd"/>
                }
              }
            </svg>
          </div>
        </div>
        
        <!-- Content -->
        <div class="ml-4 flex-1 min-w-0">
          <div [class]="getTypeLabel(toast.type)" class="type-label">
            {{ getTypeName(toast.type) }}
          </div>
          <p class="message">
            {{ toast.message }}
          </p>
        </div>
        
        <!-- Close button -->
        <div class="ml-4 flex-shrink-0">
          <button
            type="button"
            (click)="dismiss(toast.id)"
            [class]="getCloseButtonClasses(toast.type)"
            [attr.aria-label]="'Dismiss ' + toast.type + ' notification'"
          >
            <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
              <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
</div>